import { Component, computed, input } from '@angular/core';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';
import { LinkListGroupItem } from '@mwe/models';
import { isArrayWithMinOneItem } from '@mwe/utils';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-circle-dropdown',
  templateUrl: './circle-dropdown.component.html',
  imports: [NgbDropdown, NgbDropdownMenu, NgbDropdownToggle, NgClass, NgbDropdownItem, TranslatePipe],
})
export class CircleDropdownComponent {
  options = input<LinkListGroupItem[]>();
  dataTest = input<string>();
  hasBorder = input<boolean>();
  isEnabled = input<boolean>(true);
  hasOptions = computed<boolean>(() => isArrayWithMinOneItem(this.options()));
}
